// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-img-container {
  display: block;
  height: auto;
  margin-bottom: 15px;
  margin-left: auto;
  margin-right: auto;
}

.form-group-button {
  padding: 0px 0px;
}

.form-group-button-derivation .btn-secondary-derivation,
.form-group-button-derivation .btn-secondary-derivation:hover,
.form-group-button-derivation .btn-secondary-derivation:focus,
.form-group-button-derivation .btn-secondary-derivation:active {
  letter-spacing: 1px;
  background-color: #e7e7e7;
  background: #e7e7e7;
  border-color: #e7e7e7;
  color: #44474B;
}
.form-group-button-derivation button {
  width: 100%;
  border-radius: 25px;
}

.principal-title {
  margin-bottom: 15px;
}

.wc-container .wc-container-in #serviceErrorLabel {
  text-align: left;
}
.wc-container .wc-container-in .principal-title {
  text-align: left;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
